import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import InsurancePremiumsAnalytics from '@/components/insurance-sub/InsurancePremiumsAnalytics';
import InsurancePremiumsRecords from '@/components/insurance-sub/InsurancePremiumsRecords';
import { Shield } from 'lucide-react';

export default function InsurancePremiums() {
    return (
        <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <Shield className="h-8 w-8" />
                    <h1 className="text-4xl font-semibold tracking-tight">Insurance Premiums</h1>
                </div>
                <p className="text-muted-foreground">Insurance premium payment records.</p>
            </div>

            <Tabs defaultValue="analytics" className="space-y-6">
                <TabsList>
                    <TabsTrigger value="analytics">Analytics</TabsTrigger>
                    <TabsTrigger value="records">Records</TabsTrigger>
                </TabsList>

                <TabsContent value="analytics">
                    <InsurancePremiumsAnalytics />
                </TabsContent>

                <TabsContent value="records">
                    <InsurancePremiumsRecords />
                </TabsContent>
            </Tabs>
        </div>
    );
}
